import { graphql } from 'gatsby';

import { CustomerRatings, CustomerRatingsProps, RatingProps } from '@mewa/ui';

export type StrapiCustomerRatingsData = Omit<
  CustomerRatingsProps,
  'ratings'
> & {
  ratings: (Omit<RatingProps, 'footnoteIndex'> & {
    footnote: { strapi_id: string };
  })[];
};

export const query = graphql`
  fragment CustomerRatingsFragment on STRAPI_CUSTOMER_RATINGS {
    headline
    ratings {
      largeText
      smallText
      description
      footnote {
        strapi_id
      }
    }
  }
`;

export const CustomerRatingsWrapper = (
  props: StrapiCustomerRatingsData & {
    footnoteIndexes: Record<string, string>;
  },
) => {
  const ratingsWithIndexes = props.ratings.map(
    ({ description, largeText, smallText, footnote }) => ({
      description,
      largeText,
      smallText,
      footnoteIndex: props.footnoteIndexes[footnote.strapi_id],
    }),
  ) as CustomerRatingsProps['ratings'];

  return (
    <CustomerRatings
      headline={props.headline}
      ratings={ratingsWithIndexes}
      className={props.className}
    />
  );
};
